module.exports = __webpack_public_path__ + "img/bd(4).c32c6e66.png";